import * as React from "react";
import { motion } from "framer-motion";
import {
  IoHome,
  IoDocumentText,
  IoPerson,
  IoColorPalette,
  IoCodeSlash,
} from "react-icons/io5";
import { Link } from "react-router-dom";

const items = [
  { name: "Home", link: "/", icon: <IoHome /> },
  {
    name: "Resume",
    link: "https://drive.google.com/file/d/1JGQG-n5ShbzNx-hkD6rS11ooW-jyMqv4/view?usp=sharing", 
    icon: <IoDocumentText />
  },
  { name: "About Me", link: "/about", icon: <IoPerson /> },
  { name: "Art Gallery", link: "/art", icon: <IoColorPalette /> },
  { name: "Tech Projects", link: "/cs", icon: <IoCodeSlash /> }
];

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: { y: { stiffness: 1000, velocity: -100 } }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: { y: { stiffness: 1000 } }
  }
};

export const MenuItem = ({ i }) => {
  const item = items[i];
  const style = { color: item.color, display: "flex", alignItems: "center" };

  const isExternal = item.link.startsWith("http");

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <motion.li
        variants={variants}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="menu-item"
      >
        {isExternal ? (

          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="menu-link"
            style={style}
          >
            <div className="icon-placeholder" style={{ marginRight: "10px" }}>
              {item.icon}
            </div>
            <div className="text-item">{item.name}</div>
          </a>
        ) : (

          <Link to={item.link} className="menu-link" style={style}>
            <div className="icon-placeholder" style={{ marginRight: "10px" }}>
              {item.icon}
            </div>
            <div className="text-item">{item.name}</div>
          </Link>
        )}
      </motion.li>
    </motion.div>
  );
};
